import { defineStore } from "pinia";
import axios from 'axios';
import { SelectItem, UploadType } from "@/types";
import { BFieldSelection } from "@/components/BFilterEditor/BFilterEditor.types";
import { ref, computed, Ref, watch } from "vue";

interface Ori {
    ori: string;
    agency: string;
    oriAgency: string;
}

interface DatasetDetails {
    dataset_id: number;
    name: string;
    label: string;
    start_date: Date
    end_date: Date
    agency_start_date: Date
    agency_end_date: Date
    vendor_code: string;
}

export const useOriStore = defineStore('oriStore', () => {

    var oris = ref([] as Ori[]);
    var dataset = ref(undefined as (undefined | UploadType));
    var selectedOri = ref("" as string);
    var datasetDetailArray = ref([] as DatasetDetails[]);

    watch(dataset, fetchOris);

    var getOriName = computed(() => {
        return oris.value.find(f => f.ori == selectedOri.value)?.agency;
    });

    var getOrisForSelectList = computed(() => {
        return oris.value.map(it => ({
            label: `${it.ori} - ${it.agency}`,
            value: it.ori
        } as SelectItem));
    });

    var getOrisAsBFieldSelectionArray = computed(() => {
        return oris.value.map(it => ({
            text: it.agency,
            value: it.ori
        } as BFieldSelection));
    });

    var getDetailsForCurrentDataset = computed(() => {
        let current = {} as DatasetDetails;
        var dsName = '';

        switch (dataset.value) {
            case UploadType.nibrs:
                dsName = 'NIBRS';
                break;
            case UploadType.summary:
                dsName = 'SUMMARY';
                break;
            case UploadType.useOfForce:
                dsName = 'UOF';
                break;
            case UploadType.policeEmployee:
                dsName = 'PE';
                break;
            case UploadType.contacts:
                dsName = 'CONTACTS';
                break;
            case UploadType.communityPolicing:
                dsName = 'VACP';
                break;
            case UploadType.narrative:
                dsName = 'narrative';
                break;
            case UploadType.population:
                dsName = 'population';
                break;
        }

        datasetDetailArray.value.forEach((ds: DatasetDetails) => {

            if (ds.name == dsName) {
                current = ds;
            }
        });
        return current;
    });

    async function fetchAll() {
        try {
            const data = await axios.get('api/v1/ori/');
            return data;
        }
        catch (error) {
            console.error(error);
        }
    }

    async function fetchOris() {
        try {
            const data = await axios.get('api/v1/ori/filter-info/' + dataset.value);
            oris.value = data.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    async function fetchDatasetDetailsForOri() {
        try {

            if (selectedOri.value != '') {

                const data = await axios.get<DatasetDetails[]>(`api/v1/ori/${selectedOri.value}/dataset-details`);

                datasetDetailArray.value = data.data;
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    function reset() {
        oris.value = [] as Ori[];
        dataset.value = undefined;
        selectedOri.value = "" as string;
        datasetDetailArray.value = [] as DatasetDetails[];
    }

    var getSelectedOri = computed(() => { return selectedOri ?? ""; });

    function setSelectedOri(ori: string) {
        selectedOri.value = ori;
    }
    return {
        oris, selectedOri, dataset, getOriName, getOrisForSelectList, getOrisAsBFieldSelectionArray,
        getDetailsForCurrentDataset, fetchOris, fetchAll, fetchDatasetDetailsForOri, reset, getSelectedOri, setSelectedOri
    }

},
    {
        persist: true
    })

